module.exports = __webpack_public_path__ + "static/media/lockIcon.22fa0a6a.svg";